import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, authHeaders, formatErr } from "./api";
import { inputCls, Field, SaveBar, TabCard } from "./fields";

export default function ContactTab({ content, token, onSaved, onUnauthorized }) {
  const [draft, setDraft] = useState(content.contact);
  const [saving, setSaving] = useState(false);
  useEffect(() => setDraft(content.contact), [content.contact]);

  const set = (k) => (e) => setDraft({ ...draft, [k]: e.target.value });

  const save = async () => {
    const wa = (draft.whatsapp || "").replace(/\D/g, "");
    if (wa.length < 10 || wa.length > 15) return toast.error("WhatsApp number must be 10-15 digits, with country code.");
    if ((draft.phone_display || "").replace(/\D/g, "").length < 10) return toast.error("Display phone must have at least 10 digits.");
    if (draft.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(draft.email)) return toast.error("Email format looks wrong.");
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/content/contact`, { ...draft, whatsapp: wa }, authHeaders(token));
      onSaved(data);
      toast.success("Saved — live on the website now.");
    } catch (err) {
      if (err.response?.status === 401) return onUnauthorized();
      toast.error(formatErr(err, "Save failed. Try again."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <TabCard title="Contact & Business" sub="Used across the header, footer, contact page, legal pages and search schema" testid="tab-contact">
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Display phone"><input value={draft.phone_display} onChange={set("phone_display")} data-testid="contact-field-phone" className={inputCls} /></Field>
        <Field label="WhatsApp number" hint="Digits only, with country code — e.g. 917065028801"><input value={draft.whatsapp} onChange={set("whatsapp")} data-testid="contact-field-whatsapp" className={inputCls} /></Field>
        <Field label="Email"><input value={draft.email} onChange={set("email")} data-testid="contact-field-email" className={inputCls} /></Field>
        <Field label="Working hours"><input value={draft.hours} onChange={set("hours")} data-testid="contact-field-hours" className={inputCls} /></Field>
        <div className="sm:col-span-2"><Field label="Office address"><textarea rows={2} value={draft.address} onChange={set("address")} data-testid="contact-field-address" className={`${inputCls} resize-none`} /></Field></div>
        <Field label="Google Maps link" hint="Optional — makes the address clickable"><input value={draft.maps_url} onChange={set("maps_url")} placeholder="https://maps.google.com/…" data-testid="contact-field-maps" className={inputCls} /></Field>
        <Field label="Instagram link" hint="Optional"><input value={draft.instagram} onChange={set("instagram")} placeholder="https://instagram.com/…" data-testid="contact-field-instagram" className={inputCls} /></Field>
        <Field label="LinkedIn link" hint="Optional"><input value={draft.linkedin} onChange={set("linkedin")} placeholder="https://linkedin.com/company/…" data-testid="contact-field-linkedin" className={inputCls} /></Field>
      </div>
      <SaveBar onSave={save} saving={saving} lastSaved={content.saved_at?.contact} testid="contact-save" />
    </TabCard>
  );
}
